import type { GetRankingGoodsRequest } from 'shared/src/api';

export const queryKey = {
  homeTabs: () => ['homeTabs'],
  homeIcons: () => ['homeIcons'],
  rankingFilters: () => ['rankingFilters'],
  rankingGoods: (params: Omit<GetRankingGoodsRequest, 'last_ranking'>) => [
    'rankingGoods',
    params,
  ],
  marketRankingTypes: () => ['marketRankingTypes'],
  marketRankingFilterOptions: (marketTypeSno: number) => [
    'marketRankingFilterOptions',
    marketTypeSno,
  ],
  marketRankings: (params: {
    market_type_sno: number;
    category_sno?: number;
    age_list?: number[];
    style_list?: string[];
  }) => ['marketRankings', params],
  overviewCategories: () => ['overviewCategories'],
  retailAd: (adSlotId: number) => ['retailAd', adSlotId],
  homePromotionComponents: () => ['homePromotionComponents'],
} as const;
